/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

Modal.setAppElement('body');

export default function AdvisorsTCs({ showModal, onHide }) {
  return (
    <Modal isOpen={showModal} onRequestClose={onHide}>
      <button type="button" className="btn-close" onClick={onHide}>
        <span aria-hidden="true">&times;</span>
      </button>

      <h2>Outsmart Insight Advisors Terms & Conditions</h2>
      <h3>Last updated on 1st March 2021</h3>

      <p>
        Your membership and participation in Outsmart Insight Advisors is
        subject to the following terms and conditions (these "Terms &
        Conditions"). As used herein, the terms "we", "us", "our", "Outsmart
        Insight" and "Outsmart" mean Outsmart Insights Ltd., the sole owner
        and operator of Outsmart Insight Advisors. By checking the box below,
        you agree to be bound by these Terms & Conditions, as modified by us
        from time to time in our sole discretion, and that these Terms &
        Conditions supersede any prior terms and conditions between you and
        Outsmart Insight. This is a legally binding agreement. Any breach by
        you of these Terms & Conditions may result, among other things, in
        immediate termination of your membership and participation in Outsmart
        Insight Advisors.
      </p>

      <h3>OVERVIEW</h3>

      <p>
        Outsmart Insight Advisors is a network of practitioners, professionals
        and academics in various industries that provide consulting services
        to Outsmart’s clients (each, a "Client" and collectively, "Clients").
        Outsmarts Clients are investment firms, consulting firms,
        corporations, academic institutions and others who perform research.
        Based on Clients’ needs, we will contact appropriate members in
        Outsmart Insight Advisors (each, an "Advisor" and collectively,
        "Advisors") to ascertain whether they are suitable and available for a
        consulting project ("Project"), such as a telephone consultation,
        teleconference, online survey, meeting or discussion group.
      </p>

      <h3>
        CONDITIONS OF MEMBERSHIP IN OUTSMART INSIGHT ADVISORS AND
        PARTICIPATION IN CONSULTING PROJECTS
      </h3>

      <p>
        You may become an Advisor and participate in a Project if, and only
        if, all of the following compliance conditions are satisfied:
      </p>
      <ol>
        <li>
          Your membership and participation would not present any conflict of
          interest.
        </li>
        <li>
          Your membership and participation would not cause you to breach any
          agreement with or other legal obligation to any person or entity
          (including, but not limited to, your employer, your previous
          employers or any person or entity to which, or through which, you
          provide or have provided consulting services).
        </li>
        <li>
          Your membership and participation would not cause you to violate any
          duty or obligation of any kind to, or policy or code of conduct of,
          any person or entity (including, but not limited to, your employer,
          your previous employers or any company to which, or through which,
          you provide or have provided consulting services).
        </li>
        <li>
          Your membership and participation would not result in the disclosure
          of any confidential or proprietary information (including trade
          secrets) not owned exclusively by you.
        </li>
        <li>
          Your membership and participation would not result in any
          communication or disclosure to any third party of any material
          non-public information concerning any public company or security.
        </li>
        <li>
          Your membership and participation would not violate any law, rule or
          regulation.
        </li>
      </ol>

      <p>
        YOU MUST DECLINE OR DISCONTINUE PARTICIPATION IN ANY PROJECT THAT
        WOULD RESULT IN A VIOLATION OF ANY OF THE CONDITIONS ABOVE.
      </p>

      <p>
        You are solely responsible for determining whether you are permitted
        to join Outsmart Insight Advisors and to participate in Projects.
        Before applying to join Outsmart Insight Advisors, you must review any
        and all legal agreements that could restrict your ability to
        participate, including, without limitation, employment agreements,
        consulting agreements, non-disclosure agreements, employee handbooks,
        codes of ethics and similar employment policies. You should also
        consider whether you should obtain consents or waivers from your
        employer, clients or any other third parties (if applicable, in each
        instance) to ensure that you are permitted to act as an Advisor. An
        Advisor’s participation in any Project with any Client is at the
        Advisor’s sole discretion.
      </p>

      <p>
        Advisors are never obligated to accept or continue any Project and may
        decline to participate or continue to participate in any Project at
        any time.
      </p>

      <h3>YOUR COMPANY</h3>

      <p>
        You agree not to participate in a Project if the topic of the Project
        is a company for which you are a current employee, director, trustee,
        officer, or board member (or for which you hold a similar position)
        unless you are the proprietor of such company. You further agree that
        if you were previously employed in the finance or accounting
        department of a company, you will not consult about that company until
        four months after termination of your employment. If a public company
        of which you are an employee, director, trustee, officer, or board
        member (or for which you hold a similar position) is the target or
        bidder in a tender offer, or has filed to issue an IPO, you must
        decline all Projects until the tender offer is resolved or the IPO is
        issued.
      </p>

      <h3>COMPETITORS</h3>

      <p>
        You agree not to consult on a Project for a Client that is a direct
        competitor of a company for which you are a current employee,
        director, trustee, officer, or board member (or for which you hold a
        similar position).
      </p>

      <h3>GOVERNMENT EMPLOYEES</h3>

      <p>
        If you are a government employee and your employer prohibits its
        employees from participating in outside consulting projects, you may
        not be an Advisor in Outsmart Insight Advisors or participate in any
        Project. If you are a government employee who may engage in outside
        consulting, you agree not to consult about matters presently regulated
        by the agency or department in which you are employed. You further
        agree not to consult about any legislation, regulation or policy that
        you are in a position to vote upon or otherwise influence. You agree
        not to offer, pay, promise, or authorise, or accept or agree to accept
        any payment, gift or item of value to or from another person or entity
        for the purpose of seeking influence, obtaining or retaining business
        or for any other improper business advantage or purpose.
      </p>

      <h3>CLINICAL TRIAL PARTICIPANTS AND CONSULTANTS</h3>
      <p>
        If you have participated in a clinical trial or provided consulting
        services to a person or entity, you may have duties or obligations to
        treat certain related information as confidential. You must satisfy
        those duties and obligations and any other policies and requirements
        of such person or entity, your institution(s) and trial sponsors.
        Under no circumstances may you ever disclose or discuss any
        confidential information learned in the course of your consulting or
        clinical trial participation, including patient experience information
        and trial results, until such information has been made public. If you
        are a Data Safety Monitoring Board or Clinical Trial Steering
        Committee member on an ongoing clinical trial, you may not discuss the
        ongoing trial phase until it is completed and the results are made
        public.
      </p>

      <h3>ATTORNEYS AND AUDITORS</h3>
      <p>
        If you are an attorney, you agree not to consult about any clients you
        currently represent or to disclose any information or opinions that
        would breach any legal or ethical duty you or your firm owes to past
        or present clients. If you are currently an auditor or formerly an
        auditor, you agree not to consult about companies or other
        organisations that you currently audit or have audited within the last
        three years. If you are an attorney or an auditor in current practice,
        you represent that you are duly licensed to practice in the
        jurisdictions in which you currently practice, and that you are in
        good standing as a member of the Bar or other similar professional
        board to which you are subject. You agree not to provide any legal or
        professional services to a Client during a Project for that Client.
      </p>

      <h3>LEGAL PRIVILEGE</h3>
      <p>
        In the event that a Client initiates a Project involving its legal
        counsel, it is possible that the Client may wish to assert a claim of
        legal privilege concerning the Project. Under these circumstances,
        Client’s legal counsel may ask you to enter into a separate written
        engagement agreement with them for your services (an "Engagement
        Agreement"). Any such request may only come through Outsmart Insight
        and you may only choose to accept following Outsmarts prior written
        approval in its sole discretion. So approved, an Engagement Agreement
        shall control over any inconsistent terms in these Terms & Conditions
        with respect to your relationship and obligations to such Client with
        respect to the Project. Such Engagement Agreement shall be treated as
        a separate agreement in the “Application to Terms and Conditions”
        paragraph below and shall not modify your obligations to Outsmart
        Insight or third parties, under these Terms & Conditions or otherwise.
      </p>

      <h3>ANTI-CORRUPTION; FALSE OR MISLEADING INFORMATION</h3>
      <p>
        You shall not offer, give or promise to give any gift, payment,
        consideration, financial or non-financial advantage to another person
        directly or indirectly in connection with a Project or these Terms &
        Conditions. You further agree not to accept or agree to accept any
        gift, payment, consideration, financial or non-financial advantage in
        exchange for obtaining or retaining business or improperly performing
        a relevant function. You agree never to disseminate false or
        misleading information or inaccurately represent your experience,
        education, employment or knowledge to us or any Clients. You further
        agree not to mislead or misrepresent yourself to a person for any
        reason directly or indirectly related to a Project or these Terms &
        Conditions including, without limitation, for the purpose of gathering
        information from such person for a Project.
      </p>

      <h3>ACCURACY OF INFORMATION</h3>
      <p>
        You are solely responsible for the accuracy and completeness of
        information that you provide to Outsmart Insight (your “Advisor
        Information”) and you understand that Outsmart Insight, Clients and
        third parties may and will rely on your Advisor Information. You agree
        to provide us with accurate and up-to-date biographical information on
        your application and in connection with any further queries,
        including, without limitation, your current and former employment, and
        any conflicts or restrictions on your ability to consult. Based on
        further information from you or other sources, we may amend your
        Advisor Information and you acknowledge that you are under a
        continuing obligation to monitor the accuracy of your Advisor
        Information and to update changes promptly.
      </p>

      <h3>PRIVACY</h3>
      <p>
        You agree that Outsmart Insight may collect, synthesise and retain
        information about you, from sources including, without limitation,
        yourself, your activities through Outsmart Insight Advisors and
        third-party sources (hereafter, “Personal Information”). Outsmart
        Insight will treat Personal Information in accordance with Outsmart’s
        Privacy Policy (
        <a
          href="https://www.outsmartinsight.com/privacy-policy"
          target="_blank"
          rel="noreferrer"
        >
          https://www.outsmartinsight.com/privacy-policy
        </a>
        ), which is incorporated by reference. If your membership in Outsmart
        Insight Advisors ends, you agree that Outsmart Insight may preserve
        Personal Information, provided that Outsmart Insight accords such
        Personal Information the protections set forth in its then-current
        Terms & Conditions privacy policies. You agree that Outsmart Insight
        may use and share Personal Information to, without limitation, contact
        you concerning your participation in Outsmart Insight Advisors, to
        manage your membership in Outsmart Insight Advisors, to administer
        compliance policies and procedures, including obtaining required
        approvals and consents for Project participation, to market Outsmarts
        services, and to comply with applicable laws and requests from
        government authorities. You agree that we may disclose Personal
        Information as required by law, to protect Outsmarts rights, or for
        the prevention, detection or disclosure of a crime. You also recognise
        that Clients may be required by law or their compliance policies to
        disclose Personal Information about their Projects with you and you
        authorise Outsmart Insight and its Clients to make such disclosures.
        Outsmart Insight will not sell Personal Information to third-party
        marketers or similar organisations, or disclose the Personal
        Information publicly, unless you provide consent or we determine that
        it is appropriate in response to a law, regulation, rule, government
        request, prudential concern or legal process. Outsmart Insight is
        compliant with the European Union General Data Protection Regulation
        and consistent with its compliance.
      </p>

      <h3>APPLICATION OF THE TERMS & CONDITIONS</h3>
      <p>
        By becoming an Advisor, you represent and warrant to us that you are
        in compliance with each of the conditions, agreements,
        acknowledgments, representations, covenants, warranties and other
        obligations included in these Terms & Conditions. As an Advisor, you
        will be expected to provide information during any Project in good
        faith, to the best of your ability and at all times consistent with
        these Terms & Conditions.{' '}
        <i>
          You understand and acknowledge that each Outsmart Insight employee,
          affiliate, affiliate employee and Client is an intended third-party
          beneficiary of these Terms & Conditions and shall therefore have the
          right to enforce your compliance with them.
        </i>
        In certain cases, a Client may require you to make additional
        representations, acknowledgments or agreements in connection with a
        particular Project and you understand and acknowledge that the Client
        may rely on such additional representations, acknowledgments and
        agreements and enforce your compliance with them. In addition, a
        Client may require you to sign a separate agreement in connection with
        a particular Project. Outsmart Insight does not review such separate
        agreements and/or any related documents and disclaims any and all
        liability for the content of such separate agreements or any
        consequences that may arise from or relate to such separate
        agreements. You are urged to consult with your own counsel concerning
        your situation and any questions you may have before entering into any
        such separate agreement. You must decline to participate in, or to
        continue your participation in, any Project or other activity that
        would cause you to violate these Terms & Conditions and immediately
        inform us of the reason. We typically do not participate in your
        interactions with Clients and shall not be liable or responsible to
        you in any manner whatsoever for Projects arranged by us. You are
        solely responsible for ensuring your continued compliance with the
        Terms & Conditions. You agree to cooperate fully in any inquiry
        concerning actual, alleged, or potential violations of these Terms &
        Conditions.{' '}
        <i>
          To encourage your vigilance and care in complying with these Terms &
          Conditions, you may submit a payment request for a full Project that
          you choose to terminate early for the purpose of complying with
          them. You must notify Outsmart Insight immediately by emailing{' '}
          <a href="mailto:compliance@outsmartinsight.com">
            compliance@outsmartinsight.com
          </a>{' '}
          if you terminate a Project early for purposes of complying with
          Terms & Conditions.
        </i>
      </p>

      <h3>CONFIDENTIALITY</h3>
      <p>
        You shall keep and maintain as strictly confidential, and agree not to
        communicate, reveal or disclose, all “Confidential Information” of
        Outsmart Insight, Outsmart Insight Advisors or its Clients, without
        Outsmarts express written permission (which it may withhold in its
        sole discretion). “Confidential Information” includes any and all
        nonpublic information, in any form or medium, written, oral or
        otherwise, concerning or relating to Outsmart Insight, Outsmart
        Insight Advisors, any of its affiliates or any Client, including, but
        not limited to, the names of any Clients and Clients’ employees,
        questions posed by any Client and the topics discussed, information or
        materials shared, opinions expressed or work commissioned by Outsmart
        Insight or any Client. In the event that you are required to disclose
        Confidential Information under applicable law, you agree to promptly
        notify Outsmart Insight and to fully cooperate with Outsmart Insight
        in exercising any right or exemption available to prevent the
        disclosure of Confidential Information to the extent permitted under
        applicable law. You shall not use Confidential Information for any
        purpose other than those specifically permitted by these Terms &
        Conditions. Without limiting the foregoing, you shall not use
        Confidential Information for personal benefit (including for the
        purpose of making investment or trading decisions). The duty to
        maintain confidentiality hereunder shall survive until the
        Confidential Information becomes generally known to and available for
        use by the public other than as a result of a disclosure by you or any
        other person under legal obligation not to disclose the information.
      </p>

      <h3>PROJECTS</h3>
      <p>
        You shall only accept Projects with Outsmart Insight Clients
        individually arranged or explicitly approved by Outsmart Insight. If a
        Client requests additional Projects or other work, you must receive
        explicit approval from us before commencing work.{' '}
        <i>
          You will not be paid for any Project with an Outsmart Insight Client
          that was not individually arranged or explicitly approved by
          Outsmart Insight in advance
        </i>
        , even if the Project was a follow-up to a Project that was arranged
        by Outsmart Insight. If you are invited by Outsmart Insight to perform
        a Project for a Client, you should either accept or decline the
        invitation within 24 hours of issuance. Accepted Projects should be
        scheduled within five business days of the invitation. You should
        perform no more than 15 minutes of preparatory work for a Project
        without explicit approval from us. You are not permitted to invite any
        third-party to participate in any Project without Outsmarts prior
        written consent. We make no representation regarding the frequency or
        quantity of Project requests that you will receive. You understand and
        agree that certain of Outsmart Insight’s Clients may elect to record
        and/or transcribe consultations between their personnel and Advisors,
        and that Outsmart Insight will have no access to or control over any
        such recording or transcription. You similarly understand and agree
        that a Client’s compliance personnel may listen to a consultation
        without prior notice and without announcing that they have joined the
        consultation. From time to time a Client may wish to engage you as a
        speaker for an event. If you agree to participate in such a Project,
        you agree that such Client may use your name and biographical data in
        connection with publicity for such event. In exchange for the
        compensation paid to you for such a Project, you agree to release
        Outsmart Insight and the Outsmart Insight Parties (as defined in the
        Indemnification Paragraph below) and Outsmarts Clients from any and
        all claims and liabilities including, without limitation, any claim
        for libel, defamation, invasion of privacy, violation of the right of
        publicity, or commercial appropriation of name and likeness. We expect
        you to perform all Projects in a timely, diligent and professional
        manner consistent with highest industry practice.
      </p>

      <h3>PAYMENT</h3>
      <p>
        You will be paid based on your customary consulting fees, as agreed by
        you and us. You may change your consulting fee rate only upon written
        notice to us and the new rate shall be applicable only to Projects
        that occur after our receipt of your written notice and our agreement
        to the consulting fee rate. You may not reveal your billing rates and
        financial arrangements to Clients without Outsmart Insight’s prior
        written consent. Our payment system may accommodate consulting
        guidelines set forth by an Advisor’s employer, including joint payment
        to the Advisor and his or her employer, direct payment to the
        Advisor’s institution or payment to a charity of the Advisor’s choice
        Payments will be made following the completion of an Advisor’s
        consulting engagement, typically within 10 days following the
        Advisor’s request for such payment through the Outsmart Insight
        website (https://advisors.outsmartinsight.com).{' '}
        <i>
          Advisors must submit invoices for payment within 45 days after
          completion of any Project.
        </i>
      </p>

      <h3>INDEPENDENT CONTRACTOR STATUS</h3>
      <p>
        It is understood and agreed that any services performed by you under
        these Terms & Conditions shall be performed as an independent
        contractor and consultant, and you further understand and acknowledge
        that you have no authority to act or speak on Outsmarts behalf or to
        represent that you have any such authority. You shall not be deemed to
        be an employee of Outsmart Insight or any of its Clients and you shall
        not be entitled to any benefits provided by either Outsmart Insight or
        any of its Clients. You shall not identify yourself to any person or
        entity as an employee of Outsmart Insight or any of its Clients. You
        agree that you shall be personally responsible and liable for any and
        all taxes and other payments due on payments received by you for
        services provided under these Terms & Conditions. Nothing in these
        Terms & Conditions shall create a partnership or joint venture or
        establish the relationship of principal and agent or any other
        relationship of a similar nature between you, Outsmart Insight or its
        Clients. You represent that you are joining Outsmart Insight Advisors
        in your individual capacity and not as an agent or representative of
        any entity or individual (including, without limitation, any
        investment adviser), unless otherwise agreed in writing between
        Outsmart Insight and such entity or individual.
      </p>

      <h3>TERMINATION</h3>
      <p>
        You may terminate your membership in Outsmart Insight Advisors at any
        time by providing us with written notice. Likewise, Outsmart Insight
        may terminate your membership in Outsmart Insight Advisors at any time
        and for any reason without providing notice. Termination shall not
        relieve either party of its obligations under these Terms & Conditions
        intended to survive termination, which include, but are not limited
        to: Privacy, Application of the Terms & Conditions, Confidentiality,
        Non-Solicitation, Intellectual Property, Indemnification, Limitation
        of Liability, Arbitration, Governing Law and Venue and Miscellaneous.
      </p>

      <h3>INTELLECTUAL PROPERTY</h3>
      <p>
        You are solely responsible for the content that you share or create in
        connection with your performance of services hereunder. You represent
        that you own or have obtained any necessary licenses or permissions
        for any materials, regardless of form or format (hereafter, “IP”),
        that you provide to Outsmart Insight, Clients or third parties in
        connection with your performance of such services. IP that you create
        in connection with any Client Project shall be solely owned by the
        Client who requested the Project and that Client may use such IP for
        any purpose permitted under applicable law and that Client's agreement
        with Outsmart Insight. Any inventions, discoveries or improvements
        that are based in any way on any IP you create for a Client in the
        course of a Project, and all intellectual property rights in such
        inventions, discoveries or improvements, shall likewise be owned
        solely and entirely by the Client. Any IP that you created prior to,
        or independently of, any Project (hereafter, “Advisor IP”) remains
        your property. However, with respect to any Advisor IP that you share
        or otherwise provide to a Client in connection with a Project, you
        shall automatically grant that Client a perpetual, world-wide,
        royalty-free, and transferable license to use such Advisor IP. Without
        limiting the foregoing, you further agree that each Client is free to
        use any ideas, concepts, know-how, or techniques contained in any IP
        you share with or otherwise provide to that Client for any purpose
        whatsoever, including, but not limited to, devising, manufacturing,
        promoting and selling products and services using such information.
      </p>

      <h3>INDEMNIFICATION</h3>
      <p>
        You agree to indemnify and hold harmless Outsmart Insight and its
        affiliates, and their respective officers, directors, employees,
        members, managing members, managers, agents, representatives,
        successors and assigns (collectively, the “Outsmart Insight Parties”)
        from any and all actions, causes of action, claims, charges, demands,
        cost, expenses and damages (including attorneys’ fees and expenses)
        and liabilities of any kind whatsoever directly or indirectly
        resulting from, arising out of or in connection with your breach or
        violation of any and all provisions of these Terms & Conditions.
      </p>

      <h3>LIMITATION OF LIABILITY</h3>
      <p>
        YOU AGREE THAT UNDER NO CIRCUMSTANCES WILL OUTSMART INSIGHT PARTIES BE
        LIABLE TO YOU OR TO ANY OTHER PARTY FOR ANY INDIRECT, INCIDENTAL,
        CONSEQUENTIAL, EXEMPLARY OR PUNITIVE DAMAGES ARISING FROM OR RELATING
        TO YOUR SERVICES AND OTHER CONDUCT AS AN ADVISOR, OR YOUR INTERACTIONS
        OTHERWISE WITH OUTSMART INSIGHT PARTIES OR CLIENTS. OUTSMART INSIGHT
        PARTIES SHALL NOT BE LIABLE FOR ANY CLAIMS AGAINST YOU BY THIRD
        PARTIES. IN NO EVENT SHALL THE MAXIMUM CUMULATIVE LIABILITY OF
        OUTSMART INSIGHT PARTIES ARISING FROM OR RELATED TO ANY CONDUCT IN
        CONNECTION WITH THESE TERMS AND CONDITIONS EXCEED THE FEES PAID BY
        OUTSMART INSIGHT TO YOU HEREUNDER FOR THE RELEVANT CONSULTATION OR
        SURVEY IN THE MONTH SUCH LIABILITY IS ALLEGED TO HAVE ARISEN. <br />
        Outsmart Insight agrees not to seek to impose upon you liability for
        indirect, incidental, consequential, exemplary or punitive damages
        based on your performance of services under these Terms & Conditions,
        so long as such damages do not arise out of or relate to a failure by
        you to comply with these Terms & Conditions, or conduct that
        constitutes gross negligence or intentional misconduct. Collectively,
        the terms in this paragraph constitute the “Limitation of Liability.”
      </p>

      <h3>ARBITRATION, GOVERNING LAW AND VENUE</h3>
      <p>
        The validity, interpretation, performance and enforcement of these
        Terms & Conditions shall be governed by and construed in accordance
        with the laws of England. You agree that the courts of England and
        Wales shall have exclusive jurisdiction to settle any Disputes, and
        waive any objection to proceedings before such courts on the grounds
        of venue or on the grounds that such proceedings have been brought in
        an inappropriate forum. For the purposes of this Clause, “Dispute”
        means any dispute, controversy, claim or difference of whatever nature
        arising out of, relating to, or having any connection with these terms
        and conditions of service, including a dispute regarding the
        existence, formation, validity, interpretation, performance or
        termination of these terms and conditions of service or the
        consequences of its nullity and also including any dispute relating to
        any non-contractual rights or obligations arising out of, relating to,
        or having any connection with these terms and conditions of service.
      </p>

      <h3>MISCELLANEOUS</h3>
      <p>
        We may modify these Terms & Conditions from time to time by posting
        the modification(s) on our website, www.outsmartinsight.com. Unless
        otherwise specified by us when posted, all modifications will be
        effective upon posting. If you do not agree to any modification(s),
        your only recourse will be to terminate your participation as an
        Advisor in Outsmart Insight Advisors. If you continue to participate
        as an Advisor after any modification becomes effective, then your
        participation will constitute acceptance of such modification. No
        failure or delay by either party in exercising any right, power or
        privilege hereunder shall operate as a waiver thereof, nor shall any
        single or partial exercise thereof preclude any other or further
        exercise thereof or the exercise of any right, power or privilege
        hereunder. Neither these Terms & Conditions nor any of the rights,
        interests or obligations hereunder may be assigned, delegated or
        otherwise transferred, in whole or in part, by operation of law or
        otherwise, by you without our prior written consent (which consent we
        may withhold in our sole discretion), and any such assignment,
        delegation or transfer by you without such prior written consent shall
        be null and void and of no force or effect whatsoever. These Terms &
        Conditions shall be binding upon and inure solely to the benefit of
        you and Outsmart Insight, the Outsmart Insight Parties and Clients of
        Outsmart Insight. As used in these Terms & Conditions, the word
        “including” shall mean “including, without limitation,” in all cases.
        Whenever possible, each provision of these Terms & Conditions shall be
        interpreted in such manner as to be effective and valid under
        applicable law, but if any provision of these Terms & Conditions is
        held to be invalid, illegal or unenforceable in any respect, such
        invalidity, illegality or unenforceability shall not affect any other
        provision of these Terms & Conditions, and these Terms & Conditions
        shall be reformed, construed and enforced as if such invalid, illegal
        or unenforceable provision had never been contained herein.
      </p>
      <button
        type="button"
        className="c-btn c-btn--large c-btn--primary"
        onClick={onHide}
      >
        Close
      </button>
    </Modal>
  );
}

AdvisorsTCs.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};
